import Vue from 'vue';
//import { Config } from '@/models/ViewportConfig';
import Component from 'vue-class-component';
import { ProductSection, Product } from '../../models/ProductModels';
import { Viewport } from '../../models/Viewport';
//import { getProductUrl } from '../../models/UtilService';


@Component({
    name: 'ProductLink',
    props: {
        prodid: {

        },
        viewport: {

        }
    }
})

export default class ProductLink extends Vue {
    prodid: string;
    viewport: Viewport;
    public prod: Product;

    get getProductUrl(): string {

        let returnValue: string = 'undefined URL';
        if (!this.prod)
            return `http://The product with Id: ${this.prodid} not found`;
        else if (!this.prod.latestVersion)
            return `http://Latest version of Product with Id: ${this.prodid} not found`;
        else
            return this.prod.latestVersion.spaceUrl?this.prod.latestVersion.spaceUrl:process.env.VUE_APP_SERVER_BASE_ADRESS+'/index/error';
        
    }

    created() {
        this.prod = this.viewport.utilserv.productStructur.
            products[this.prodid];

            
    }
}


